// Thinknerve custom JS for Aurora theme.
// Loaded with `defer` after the main Vite bundle in layout/theme.liquid,
// so the DOM is parsed and the theme's globals are available when this runs.

// Smooth-scroll for any anchor with [data-tn-scroll-target] (a Shopify section.id).
// Used by TN section button settings that take a "section id" as a scroll target.
(function () {
  function getHeaderOffset() {
    // Aurora makes the header SECTION WRAPPER sticky (position: sticky on
    // .shopify-section-header), not the <header-component> itself, and it doesn't
    // reliably expose --gsc-header-height on :root. So find the header element and
    // walk up to whichever ancestor is actually sticky/fixed, then measure it.
    const header = document.getElementById('header-component') || document.querySelector('header-component');
    if (!header) return 0;

    let el = header;
    while (el && el !== document.body) {
      const pos = getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') {
        return el.getBoundingClientRect().height + 16; // + small breathing gap
      }
      el = el.parentElement;
    }
    // Header isn't sticky at this viewport — it scrolls away, so no offset needed.
    return 0;
  }

  document.addEventListener('click', function (e) {
    const a = e.target.closest('a[data-tn-scroll-target]');
    if (!a) return;
    const id = a.getAttribute('data-tn-scroll-target');
    if (!id) return;
    const el = document.getElementById('shopify-section-' + id) || document.getElementById(id);
    if (!el) {
      console.warn('[tn-scroll] no element found for id:', id);
      return;
    }
    e.preventDefault();

    const scroller = document.scrollingElement || document.documentElement;
    const offset = getHeaderOffset();

    // Set the section's scroll offset as a CSS property so the browser lands it
    // below the sticky header. Persisted so it stays correct if layout shifts.
    el.style.scrollMarginTop = offset + 'px';

    function targetY() {
      return Math.max(0, el.getBoundingClientRect().top + scroller.scrollTop - offset);
    }

    // Smooth scroll for the initial animation.
    window.scrollTo({ top: targetY(), behavior: 'smooth' });

    // A long smooth scroll drifts/stops early when lazy-loaded media above the
    // target shifts layout mid-animation. Once motion settles, snap INSTANTLY to
    // the exact position (an instant set can't be interrupted), and repeat while
    // late-loading content keeps shifting things.
    let lastY = null;
    let stable = 0;
    let snaps = 0;
    const timer = setInterval(function () {
      const y = scroller.scrollTop;
      if (lastY !== null && Math.abs(y - lastY) < 1) stable++;
      else stable = 0;
      lastY = y;

      if (stable >= 2) {
        if (Math.abs(targetY() - scroller.scrollTop) > 2 && snaps < 6) {
          snaps++;
          stable = 0;
          scroller.scrollTop = targetY(); // instant, exact — no drift
        } else {
          clearInterval(timer);
        }
      }
    }, 100);
    setTimeout(function () { clearInterval(timer); }, 6000);
  });
})();

// Klaviyo custom inline newsletter form — posts to Klaviyo Client Subscriptions API.
// Triggered for any <form> inside [data-tn-klaviyo]. Reads company_id + list_id from
// the wrapper's data attributes.
(function () {
  const KLAVIYO_REVISION = '2024-10-15';

  function isValidEmail(s) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
  }

  // --- Paid-media attribution -------------------------------------------------
  // Capture UTM + ad click IDs on landing, persist 7 days (last-touch, matching
  // Google/Meta click windows), then attach them as Klaviyo profile properties
  // on signup so paid vs organic can be segmented in Klaviyo.
  const ATTR_COOKIE = 'tn_attribution';
  const ATTR_TTL_DAYS = 7;
  const ATTR_KEYS = [
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
    'gclid', 'fbclid', 'wbraid', 'gbraid',
  ];

  function readCookie(name) {
    const match = document.cookie.match(
      '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'
    );
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function captureAttribution() {
    const params = new URLSearchParams(window.location.search);
    const captured = {};
    ATTR_KEYS.forEach(function (k) {
      const v = params.get(k);
      if (v) captured[k] = v;
    });
    // Last-touch: only overwrite (and reset the 7-day clock) when this landing
    // carries attribution params. Pages without params keep the prior capture.
    if (Object.keys(captured).length) {
      writeCookie(ATTR_COOKIE, JSON.stringify(captured), ATTR_TTL_DAYS);
    }
  }

  function deriveChannel(attr) {
    const hasClickId = ['gclid', 'fbclid', 'wbraid', 'gbraid'].some(function (k) {
      return attr[k];
    });
    const medium = (attr.utm_medium || '').toLowerCase();
    const paidMediums = [
      'cpc', 'ppc', 'paid', 'paidsocial', 'paid_social', 'paid-social',
      'paidsearch', 'paid_search', 'display', 'cpm', 'retargeting',
    ];
    if (hasClickId || paidMediums.indexOf(medium) !== -1) return 'paid';
    return Object.keys(attr).length ? 'organic' : 'direct';
  }

  function getAttributionProperties() {
    let attr = {};
    const raw = readCookie(ATTR_COOKIE);
    if (raw) {
      try { attr = JSON.parse(raw) || {}; } catch (e) { attr = {}; }
    }
    const props = {};
    ATTR_KEYS.forEach(function (k) {
      if (attr[k]) props[k] = attr[k];
    });
    props.signup_channel = deriveChannel(attr);
    return props;
  }

  captureAttribution();

  // Fire a GA4 event so newsletter signups can drive GA4 flows / conversions.
  // Works with gtag.js (direct GA4) and GTM (dataLayer trigger). Each consumer
  // ignores the other's mechanism, so this won't double-count in a single setup.
  function trackGA4Event(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params || {});
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params || {}));
    } catch (e) {}
  }

  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const wrapper = form.closest('[data-tn-klaviyo]');
    if (!wrapper) return;

    e.preventDefault();

    const companyId = wrapper.getAttribute('data-tn-klaviyo-company');
    const listId = wrapper.getAttribute('data-tn-klaviyo-list');
    const customSource = wrapper.getAttribute('data-tn-klaviyo-source') || 'Newsletter signup';
    if (!companyId || !listId) return;

    const emailInput = form.querySelector('input[type="email"]');
    const email = (emailInput && emailInput.value || '').trim();

    const successEl = wrapper.querySelector('.tn-klaviyo__message--success');
    const validationEl = wrapper.querySelector('.tn-klaviyo__message--validation');
    const errorEl = wrapper.querySelector('.tn-klaviyo__message--error');
    const submitBtn = form.querySelector('button[type="submit"]');

    if (successEl) successEl.hidden = true;
    if (validationEl) validationEl.hidden = true;
    if (errorEl) errorEl.hidden = true;
    wrapper.removeAttribute('data-tn-klaviyo-state');

    if (!email || !isValidEmail(email)) {
      if (validationEl) validationEl.hidden = false;
      wrapper.setAttribute('data-tn-klaviyo-state', 'invalid');
      if (emailInput) emailInput.focus();
      return;
    }

    wrapper.setAttribute('data-tn-klaviyo-loading', '');
    if (submitBtn) submitBtn.disabled = true;

    const attributionProps = getAttributionProperties();

    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: customSource,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: attributionProps,
              },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: listId } },
        },
      },
    };

    try {
      const res = await fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: KLAVIYO_REVISION,
          },
          body: JSON.stringify(body),
        }
      );
      // Klaviyo returns 202 Accepted on success.
      if (res.status === 202 || res.ok) {
        wrapper.setAttribute('data-tn-klaviyo-state', 'success');
        if (successEl) successEl.hidden = false;
        form.reset();
        trackGA4Event('klaviyo_inline_newsletter', {
          custom_source: customSource,
          signup_channel: attributionProps.signup_channel,
        });
      } else {
        wrapper.setAttribute('data-tn-klaviyo-state', 'error');
        if (errorEl) errorEl.hidden = false;
      }
    } catch (err) {
      wrapper.setAttribute('data-tn-klaviyo-state', 'error');
      if (errorEl) errorEl.hidden = false;
    } finally {
      wrapper.removeAttribute('data-tn-klaviyo-loading');
      if (submitBtn) submitBtn.disabled = false;
    }
  });
})();
